(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kin-morrow-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cookieRead = (key) => {
      const prefix = encodeURIComponent(key) + '=';
      const item = document.cookie.split('; ').find((entry) => entry.startsWith(prefix));
      return item ? decodeURIComponent(item.slice(prefix.length)) : null;
    };

    const readExpiry = (key) => {
      try {
        return localStorage.getItem(key) || cookieRead(key);
      } catch (error) {
        return cookieRead(key);
      }
    };

    const writeExpiry = (key, value) => {
      try {
        localStorage.setItem(key, value);
      } catch (error) {
        void error;
      }
      document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value) + '; Max-Age=31536000; Path=/; SameSite=Lax';
    };

    const initialize = (root) => {
      if (root.dataset.kmInitialized === 'true') return;
      root.dataset.kmInitialized = 'true';

      const duration = Math.max(1, Number(root.dataset.durationHours) || 24) * 60 * 60 * 1000;
      const storageKey = root.dataset.storageKey || 'kin-morrow-countdown';
      const now = Date.now();
      const saved = Number(readExpiry(storageKey));
      const expiry = Number.isFinite(saved) && saved > now ? saved : now + duration;

      if (expiry !== saved) writeExpiry(storageKey, String(expiry));

      const fields = {
        days: root.querySelector('[data-km-days]'),
        hours: root.querySelector('[data-km-hours]'),
        minutes: root.querySelector('[data-km-minutes]'),
        seconds: root.querySelector('[data-km-seconds]')
      };

      const render = () => {
        const remaining = Math.max(0, expiry - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        fields.days.textContent = String(days).padStart(2, '0');
        fields.hours.textContent = String(hours).padStart(2, '0');
        fields.minutes.textContent = String(minutes).padStart(2, '0');
        fields.seconds.textContent = String(seconds).padStart(2, '0');

        if (remaining <= 0) clearInterval(root.kmCountdownInterval);
      };

      render();
      root.kmCountdownInterval = setInterval(render, 1000);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-km-countdown]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('km-product-countdown')) {
customElements.define('km-product-countdown', class extends HTMLElement {
connectedCallback() {
clearInterval(this.clock);
const amount = name => Math.max(0, Number(this.dataset[name]) || 0);
const duration = (amount("days") * 86400 + amount("hours") * 3600 + amount("minutes") * 60 + amount("seconds")) * 1000;
const key = (this.dataset.key || 'kin-morrow-offer') + ':v2:' + duration;
const preview = this.dataset.preview === 'true';
const prefix = encodeURIComponent(key) + '=';
let stored;
try { stored = localStorage.getItem(key); } catch (_) {}
if (!stored) {const cookie = document.cookie.split('; ').find(item => item.startsWith(prefix));if (cookie) stored = decodeURIComponent(cookie.slice(prefix.length));}
const now = Date.now();const saved = Number(stored);
this.deadline = !preview && Number.isFinite(saved) && saved > now ? saved : now + duration;
if (!preview && this.deadline !== saved) {try {localStorage.setItem(key, String(this.deadline));} catch (_) {}document.cookie = prefix + this.deadline + '; Max-Age=31536000; Path=/; SameSite=Lax';}
const update = () => {const total = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));const values = {days:Math.floor(total/86400),hours:Math.floor(total%86400/3600),minutes:Math.floor(total%3600/60),seconds:total%60};Object.entries(values).forEach(([unit,value])=>{this.querySelector('[data-unit="'+unit+'"]').textContent=String(value).padStart(2,'0');});if(!total)clearInterval(this.clock);};
update();this.clock=setInterval(update,1000);
}
disconnectedCallback(){clearInterval(this.clock);}
});
}

  } catch(e) { console.error(e); }
})();
})();
